import { Endpoint } from '../endpoint';
import { FontResponse, GeocodeResponse, PlacesAddressResponse, PlacesResponse } from '@business/entities/google';

export function fonts(search: string) {
  return Endpoint.get<FontResponse[]>('@gc/google/fonts', { params: { search } });
}

export function getPlaces(input: string, type?: string) {
  return Endpoint.post<PlacesResponse>('@gc/google/autocomplete-places', { data: { input, type } });
}

export function getAddress(placeId: string) {
  return Endpoint.post<PlacesAddressResponse>('@gc/google/autocomplete-address', { data: { placeId } });
}

export function geocodeAddress(address: string) {
  return Endpoint.post<GeocodeResponse>('@gc/google/geocode', { data: { address } });
}
